module.exports = __webpack_public_path__ + "82829fd395e4f8c51e5bae65225f0908.svg";